<template>
  <div style="background-color: #fff;">
    <FilterInfo :list="getFilterInfo" @changeValue="getFilterSearch($event)" :child="'achievements'" :isfenlie="'true'" />
    <div class="listBigBox">
      <div class="industrialBox">
        <!-- <div class="industrialTitleBox">
          <div class="industrialTitle">
            成果评价
          </div>
        </div> -->
        <div class="recruitmentContentBox">
          <div class="recruitmentSmallBox">
            <div class="recruitmentSmallInfo" v-for="(item, index) in dataSource" :key="index" @click="goDetail(item)">
              <div class="mask"></div>
              <div class="btn">
                <a-button style="background-color: #fc550b;color: #fff;">查看详情</a-button>
              </div>
              <div class="recruitmentBottomBox">
                <!-- <div class="recruitmentBottomTopBox">
                  <img :src="getImg(item.companyLogo)" alt="">
                </div> -->
                <div class="recruitmentBottomMiddleBox">{{ item.name }}<div class="recruitmentBottomRightBottom">
                  </div>
                </div>
                <div class="recruitmentBottomBottomBox">{{ item.achievementAbstract }}</div>
              </div>
            </div>
          </div>
        </div>
        <!--分页-->
        <div class="pagination">
          <a-pagination v-model="current" :total="total" :page-size="pageSize" showQuickJumper @change="onChange" />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { getDistMixin, listMixin } from "@/mixins";
import FilterInfo from '@/components/other/FilterInfo';
import { achievementFontInfo } from "@/api/achievementsService";
import { file_service } from "@/api/adminService";

export default {
  name: 'innovationBigData',
  mixins: [getDistMixin, listMixin],
  components: { FilterInfo },
  data() {
    return {
      title: '',
      queryParamFixed: { achievementTransactionClassify: '0' },
      listUrl: achievementFontInfo.tradeList,
      current: 1,
      pageSize: 8,
    }
  },
  mounted() {
    this.getDist('belong_techField')
    this.getDist('technical_maturity')
    this.getDist('result_type')
    this.title = this.$route.query.type
  },
  computed: {
    getFilterInfo() {
      let list = []
      let obj = {}
      let obj1 = {}
      let obj2 = {}
      let obj3 = {}
      obj1['行业分类'] = this.technoSphereArr
      obj['search'] = 'technoSphere'
      obj2['arr'] = obj1
      obj3 = Object.assign(obj, obj2)
      list.push(obj3)
      return list
    }
  },
  methods: {
    getImg(imgUrl) {
      return file_service.imagesWeb(imgUrl)
    },
    goDetail(item) {
      this.$router.push({
        path: '/achievements/components/achievementEvelutionDetailNew',
        query: { type: '技术转让', id: item.id }
      })
    }
  }
}
</script>
<style scoped lang="less">
.listBigBox {
  width: 100%;
  margin: 10px auto;

  .industrialBox {
    width: 100%;
    margin: 20px auto;

    .industrialTitleBox {
      overflow: hidden;
      width: 100%;
      padding: 15px 0 8px 0;
      margin-bottom: 10px;
      border-bottom: 1px solid #dedede;

      .industrialTitle {
        float: left;
        font-size: 20px;
        color: #333;
      }

      .industrialTitle::before {
        content: '';
        padding-left: 12px;
        border-left: 4px solid #fc550b;
      }

      .MoreBox {
        float: right;
        color: #999;
        font-size: 14px;
        cursor: pointer;
      }
    }

    .recruitmentContentBox {
      padding: 14px 0;
      width: 100%;
      min-height: 300px;

      .recruitmentSmallBox {
        width: 100%;

        .recruitmentSmallInfo {
          margin: 10px 0;
          width: 100%;
          border: 1px solid #dedede;
          cursor: pointer;
          position: relative;

          .mask {
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            display: none;
            background-color: #4c4c4c;
          }

          .btn {
            position: absolute;
            top: 40%;
            left: 47%;
            display: none;
          }

          .recruitmentBottomBox {
            overflow: hidden;
            padding: 10px 12px 0 12px;
            width: 100%;
            color: #333;
            font-size: 14px;
            // text-align: center;

            .recruitmentBottomTopBox {
              width: 44px;
              height: 44px;
              margin: 10px auto;
              border: 1px solid #dedede;

              img {
                width: 100%;
                height: 100%;
              }
            }

            .recruitmentBottomMiddleBox {
              padding: 12px 0;
              font-size: 16px;
            }

            .recruitmentBottomBottomBox {
              color: #666;
              overflow: hidden;
              min-height: 44px;
              margin: 10px 0;
              text-overflow: ellipsis;
              -o-text-overflow: ellipsis;
              display: -webkit-box;
              -webkit-line-clamp: 2;
              -webkit-box-orient: vertical;
            }

            .recruitmentBottomBottomBottomBox {
              padding: 8px 0;
              color: #999;
            }
          }
        }

        .recruitmentSmallInfo:hover {
          border: none;
          -webkit-transition: all 0.3s ease 0s;
          transition: all 0.3s ease 0s;
          //border: 1px solid #ffffff;
          cursor: pointer;
          -webkit-box-shadow: 0 5px 10px 1px #d2e6ff;
          box-shadow: 0 5px 10px 1px #d2e6ff;

          .mask {
            display: block;
            opacity: 0.7;
          }
          .btn {
            display: block;
          }
        }
      }
    }

    .pagination {
      text-align: center;
      margin-bottom: 20px;
    }
  }
}
</style>